import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    // Notifications list — only filter by target/status, no pagination per documentation
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_NOTIFICATIONS, {
      queryParams: {
        target: payload?.target || undefined,
        status: payload?.status || undefined,
        service: "rapidoo",
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to contact server',
        data: null,
        raw,
      }
    }

    // Handle both data: { data: [...] } and data: { notifications: [...] } and data: [...]
    const res = raw.data || {}
    const notificationsData = Array.isArray(res) ? res
      : (Array.isArray(res.data) ? res.data
      : (Array.isArray(res.notifications) ? res.notifications : []))

    // === Mapping des données ===
    let data = notificationsData.map(el => {
      const meta = el.data || el.metadata || {}
      return {
        id: el.id,
        title: el.title || '',
        description: el.message || el.description || el.body || '',
        zone: meta.zone || el.zone || [],
        date: el.createdAt || meta.scheduledAt || el.date || null,
        target: el.target||"all",
        status: meta.status || el.status || 'sent',
        createdAt: el.createdAt || null,
        updatedAt: el.updatedAt || null,
        createdBy: meta.createdBy || el.createdBy || 'admin',
      }
    })

    // === Recherche textuelle ===
    if (payload?.search) {
      const searchLower = payload.search.toString().toLowerCase()
      data = data.filter(el => {
        // Identifiant
        if (el?.id?.toLowerCase().includes(searchLower)) return true

        // Notification info
        if (el?.title?.toLowerCase().includes(searchLower)) return true
        if (el?.description?.toLowerCase().includes(searchLower)) return true

        // Zone (tableau de villes/lieux)
        if (Array.isArray(el?.zone) && el.zone.some(z => z?.toLowerCase().includes(searchLower))) return true

        // Cible
        if (el?.target?.toLowerCase().includes(searchLower)) return true
        if (el?.targetRankName?.toLowerCase().includes(searchLower)) return true
        if (el?.targetRankId?.toLowerCase().includes(searchLower)) return true

        // Statut et créateur
        if (el?.status?.toLowerCase().includes(searchLower)) return true
        if (el?.createdBy?.toLowerCase().includes(searchLower)) return true

        // Dates (jour, mois, année)
        if (el?.date || el?.createdAt) {
          const date = new Date(el.date || el.createdAt)
          const dateStr = date.toLocaleDateString('fr-FR')
          const dayName = date.toLocaleDateString('fr-FR', { weekday: 'long' })
          const monthName = date.toLocaleDateString('fr-FR', { month: 'long' })
          const year = date.getFullYear().toString()

          if (dateStr.toLowerCase().includes(searchLower)) return true
          if (dayName.toLowerCase().includes(searchLower)) return true
          if (monthName.toLowerCase().includes(searchLower)) return true
          if (year.includes(searchLower)) return true
        }

        return false
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]

        // Gestion des strings et nombres
        if (typeof valA === 'string' && typeof valB === 'string') {
          return valA.localeCompare(valB) * order
        }
        if (typeof valA === 'number' && typeof valB === 'number') {
          return (valA - valB) * order
        }
        return 0
      })
    }

    const { page = 0, limit = 20 } = payload || {}
    // The API already paginates, but we might want further slicing if client-side search occurred
    const paginated = payload?.search ? data.slice(page * limit, (page + 1) * limit) : data

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: payload?.search ? data.length : (raw.data?.pagination?.total || data.length),
        result: paginated,
      },
    }
  },
}
